import QuestionsModal from './QuestionsModal.jsx'

export default QuestionsModal
